import axios from "axios";

export const createEventAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/events/createEvent`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response.data;
};

export const getAllEventAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/events/getAllEvents?page=${payload.page}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response.data;
};

export const editEventAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/events/updateEvent?eventId=${payload.eventId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const deleteEventAction = async (payload) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/events/deleteEvent?eventId=${payload.eventId}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};



export const checkDateFunction = async (payload) => { 
  
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/events/checkDateInEventRange`,
    payload.body
  );
  return response;
};